import { render, staticRenderFns } from "./PrivacyAgreement.vue?vue&type=template&id=78d25e15&scoped=true&"
import script from "./PrivacyAgreement.vue?vue&type=script&lang=js&"
export * from "./PrivacyAgreement.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyAgreement.vue?vue&type=style&index=0&id=78d25e15&prod&lang=less&scoped=true&"
import style1 from "./PrivacyAgreement.vue?vue&type=style&index=1&id=78d25e15&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d25e15",
  null
  
)

export default component.exports